import React, { forwardRef } from 'react'
import classNames from 'classnames'
import { Input } from 'antd'

import { Icon } from '@app/components/util'

import { ICON_NAME } from '@app/constants/icon'

import styles from './styles.module.scss'

import type { ForwardRefRenderFunction } from 'react'
import type { InputRef } from 'antd'
import type { LntInputSearchProps } from './types'

const Component: ForwardRefRenderFunction<InputRef, LntInputSearchProps> = (props, ref) => {
  const { className: outerClassName, ...restProps } = props

  const className: string = classNames(styles.lntInputSearch, outerClassName)

  return (
    <Input
      { ...restProps }
      className={ className }
      suffix={ <Icon name={ ICON_NAME.search } /> }
      ref={ ref }
    />
  )
}

export const LntInputSearch = forwardRef<InputRef, LntInputSearchProps>(Component)
